const QUANTITY_FIELDS = ["po_QTY", "qty", "quantity", "Qty"];
export const PRINT_PIECE_COUNT_FIELD = "__print_piece_count";

export const formatWeightValue = (value) => {
  const rawValue = String(value ?? "").trim();
  if (!rawValue) return "";

  const numericValue = Number(rawValue.replace(/,/g, ""));
  return Number.isFinite(numericValue) ? numericValue.toFixed(2) : rawValue;
};

export const getPrintItemKey = (item) => String(
  item?.id ?? item?._id ?? item?.stock_id ?? item?.SKU ?? ""
);

export const getPrintQuantity = (item) => {
  const quantityValue = QUANTITY_FIELDS
    .map((field) => item?.[field])
    .find((value) => value !== undefined && value !== null && value !== "");
  const quantity = Number(quantityValue);

  return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 1;
};

const multiplyWeight = (value, quantity) => {
  if (quantity <= 1 || value === undefined || value === null || value === "") {
    return value;
  }

  const numericValue = Number(String(value).replace(/,/g, "").trim());
  if (!Number.isFinite(numericValue)) {
    return value;
  }

  return (numericValue * quantity).toFixed(2).replace(/\.?0+$/, "");
};

const getSelectedKeys = (selectedItemKeys) => {
  if (selectedItemKeys === undefined) {
    return new Set();
  }

  return new Set((selectedItemKeys || []).map((key) => String(key)));
};

export const getPrintPieceCount = (item) => {
  const count = Number(item?.[PRINT_PIECE_COUNT_FIELD]);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 1;
};

// Build the data consumed by the barcode templates. A normal label combines
// the item's per-piece weight and shows the total piece count. Selected items
// can instead be expanded into one label per piece without dividing weight.
export const prepareItemsForPrint = (items = [], selectedItemKeys = []) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const selectedKeys = getSelectedKeys(selectedItemKeys);

  return items.flatMap((item) => {
    const quantity = getPrintQuantity(item);
    const isSplit = selectedKeys.has(getPrintItemKey(item));

    if (isSplit) {
      return Array.from({ length: quantity }, () => ({
        ...item,
        [PRINT_PIECE_COUNT_FIELD]: 1,
      }));
    }

    return [{
      ...item,
      NetWt: multiplyWeight(item?.NetWt, quantity),
      GrossWt: multiplyWeight(item?.GrossWt, quantity),
      [PRINT_PIECE_COUNT_FIELD]: quantity,
    }];
  });
};

export const expandItemsByQuantity = (items = []) => (
  prepareItemsForPrint(items, items.map(getPrintItemKey))
);

export const expandItemsByQuantityForSelection = (items = [], selectedItemKeys = []) => {
  return prepareItemsForPrint(items, selectedItemKeys);
};

export const getTotalPrintQuantity = (items = []) => (
  Array.isArray(items)
    ? items.reduce((total, item) => total + getPrintQuantity(item), 0)
    : 0
);
